import GlobalDialog from './GlobalDialog';

export default GlobalDialog;
